import { Stack, Typography } from '@mui/material';
import { EnumProjectStatus, EnumTimedProjectStatus } from 'tdc-web-backend/enums/enums';
import { ProjectStatsDto } from 'tdc-web-backend/projects/schemas';
import { TimedProjectStatsDto } from 'tdc-web-backend/timed-project-contents/schemas';
import { useTranslation } from 'react-i18next';
import { primaryDark } from '../../../../../../utils/color';
import useGetOne from '../../../../../../utils/hooks/crud-hooks/useGetOne';

const NumbersClient = () => {
  const { t } = useTranslation();
  const { data: projects, isLoading: isLoadingProjects } = useGetOne<ProjectStatsDto>({
    resource: `projects/stats?as=client`,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
    // onSuccess: (data) => {
    //   setIsTokenValid(true);
    // },
    // onError: () => {
    //   setIsTokenValid(false);
    // },
  });

  const { data: timedProjects, isLoading: isLoadingTimedProjects } =
    useGetOne<TimedProjectStatsDto>({
      resource: `timed-projects/stats`,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
    });

  const activeProjects = projects?.data.filter(
    (status) => status.status === EnumProjectStatus.InProgress,
  )[0];
  const pendingProjects = projects?.data.filter(
    (status) => status.status === EnumProjectStatus.Pending,
  )[0];

  const activeTimedProjects = timedProjects?.data.filter(
    (status) => status.status === EnumTimedProjectStatus.Active,
  )[0];

  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      spacing={8}
      sx={{ py: '50px' }}
    >
      <Stack direction="column" justifyContent="space-between" spacing={12}>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('homescreen.activeProjects')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {activeProjects?.count || 0}{' '}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('common.tenders')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {activeTimedProjects?.count || 0}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{ minHeight: '226px' }}
        direction="column"
        justifyContent="space-between"
        spacing={12}
      >
        <Stack spacing={2}>
          <Typography variant="heading4" sx={{ color: primaryDark[500] }}>
            {t('homescreen.pendingProjects')}
          </Typography>
          <Typography variant="heading1" sx={{ color: primaryDark[600] }}>
            {pendingProjects?.count || 0}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NumbersClient;
